import axios from "axios"
import {fetchUrl, fetchClientZoneUrl} from "./constants/constants"
import fetchErrorCtrl from "./helpers/fetchErrorCtrl"
import _isEmpty from "lodash/isEmpty"
import setAuthTokens from "./helpers/setAuthTokens"

export const setColorTheme = (id, dark_theme) => {
    return axios({
        method: 'PUT',
        url: fetchUrl + 'user-theme/',
        data: {theme_fk: id, dark_theme}
    }).then(res => {
        return res.data
    }).catch(err => {
        return false
    })
}

export function getClientAnalysisOrForm(id, type) {
    return axios({
        method: 'POST',
        url: `${fetchUrl}create-${type}/${id}/`
    }).then(res => {
            return {
                data: res.data,
                success: true
            }
        }
    ).catch(err => {
        return {
            data: err.response.status == 400 ? err.response.data : false,
            success: false
        }
    })
}

export function checkRoleRegistrationHash(hash) {
    return axios({
        method: 'POST',
        url: `${fetchUrl}check-role-reg-hash/`,
        data: {hash}
    }).then(res => {
            return res.data
        }
    ).catch(err => {
        return false
    })
}

export const registerRoleUser = (data) => {
    return axios({
        method: 'POST',
        url: fetchUrl + 'finish-role-registration/',
        data: data
    }).then(res => {
        return true
    }).catch(err => {
        return fetchErrorCtrl(err)
    })
}

export function checkClientRegistrationHash(hash) {
    return axios({
        method: 'POST',
        url: `${fetchClientZoneUrl}check-client-reg-hash/`,
        data: {hash}
    }).then(res => {
            return res.data
        }
    ).catch(err => {
        return false
    })
}

export const registerClient = (data) => {
    return axios({
        method: 'POST',
        url: fetchClientZoneUrl + 'finish-client-registration/',
        data: data
    }).then(res => {
        return true
    }).catch(err => {
        return fetchErrorCtrl(err)
    })
}

export function checkSigningHash(hash) {
    return axios({
        method: 'POST',
        url: `${fetchUrl}check-hash/`,
        data: {hash}
    }).then(res => {
            return res.data
        }
    ).catch(err => {
        return false
    })
}

export function checkDocRequestHash(hash) {
    return axios({
        method: 'POST',
        url: `${fetchUrl}check-doc-request-hash/`,
        data: {hash}
    }).then(res => {
            return res.data
        }
    ).catch(err => {
        return false
    })
}

export function sendSmsPin(hash) {
    return axios({
        method: 'POST',
        url: `${fetchUrl}generate-pin/`,
        data: {hash}
    }).then(res => {
            return res.data || []
        }
    ).catch(err => {
        return false
    })
}

export function checkSmsPin(data) {
    return axios({
        method: 'POST',
        url: `${fetchUrl}check-pin/`,
        data
    }).then(res => {
            return res.data
        }
    ).catch(err => {
        return false
    })
}

export function saveSignature(data) {
    return axios({
        method: 'POST',
        url: `${fetchUrl}check-signature/`,
        data
    }).then(res => {
            return true
        }
    ).catch(err => {
        return false
    })
}

export function getDocumentsToSign(data) {
    return axios({
        method: 'POST',
        url: `${fetchUrl}doc-to-sign/`,
        data
    }).then(res => {
            return res.data
        }
    ).catch(err => {
        return false
    })
}

export function smsSigningConfirmation(hash, type) {
    return axios({
        method: 'POST',
        url: `${fetchUrl}${type ? "doc-confirm" : "doc-refuse"}/`,
        data: {hash}
    }).then(res => {
            return res.data || true
        }
    ).catch(err => {
        return false
    })
}

export function missingTranslation(code) {
    return axios({
        method: 'POST',
        url: `${fetchUrl}missing-translation/${code}/`
    }).then(res => {
            return true
        }
    ).catch(err => {
        return false
    })
}

export function loadDefaultValue(identifier) {
    return axios({
        method: 'GET',
        url: `${fetchUrl}default-data/${identifier}/`,
    }).then(res => {
        return res.data
    }).catch(err => {
        return false
    })
}

export function sendGameScore(data) {
    return axios({
        method: 'POST',
        url: `${fetchUrl}game/`,
        data
    }).then(res => {
            return res.data
        }
    ).catch(err => {
        const errors = fetchErrorCtrl(err)
        return errors
    })
}

export function inputCallbackLoad(endpoint, params) {
    return axios({
        url: `${fetchUrl}callback-load/${endpoint}`,
        params
    }).then(res => {
        return {
            success: true,
            data: res.data.set_data || {}
        }
    }).catch(err => {
        return {
            success: false,
            errors: fetchErrorCtrl(err)
        }
    })
}

export function inputAutocompleteLoad(endpoint, params) {
    return axios({
        url: `${fetchUrl}autocomplete/${endpoint}`,
        params
    }).then(res => {
        return res.data
    }).catch(err => {
        return []
    })
}

export function dispatchSimpleContracts(data, type) {
    return axios({
        method: "POST",
        url: `${fetchUrl}contracts-simpledispatch-${type}/`,
        data
    }).then(res => {
        return res.data
    }).catch(err => {
        return false
    })
}

export function dispatchSimpleConfirmContracts(data, type) {
    return axios({
        method: "POST",
        url: `${fetchUrl}contracts-simpledispatch-confirm-${type}/`,
        data
    }).then(res => {
        return {
            success: true
        }
    }).catch(err => {
        return {
            success: false,
            errors: fetchErrorCtrl(err)
        }
    })
}

export function dispatchAdvisorContracts(data) {
    return axios({
        method: "POST",
        url: `${fetchUrl}contracts-dispatch-advisor/`,
        data
    }).then(res => {
        return res.data
    }).catch(err => {
        return false
    })
}

export function dispatchAdvisorPdfContracts(data) {
    return axios({
        method: "POST",
        url: `${fetchUrl}contracts-dispatch-pdf-advisor/`,
        data
    }).then(res => {
        return {
            success: true,
            data: res.data
        }
    }).catch(err => {
        return {
            success: false,
            errors: fetchErrorCtrl(err)
        }
    })
}

export function dispatchBoContracts(data) {
    return axios({
        method: "POST",
        url: `${fetchUrl}contracts-dispatch-bo/`,
        data
    }).then(res => {
        return res.data
    }).catch(err => {
        return false

    })
}

export function dispatchBoPdfContracts(data) {
    return axios({
        method: "POST",
        url: `${fetchUrl}contracts-dispatch-pdf-bo/`,
        data
    }).then(res => {
        return {
            success: true,
            data: res.data
        }
    }).catch(err => {
        return {
            success: false,
            errors: fetchErrorCtrl(err)
        }
    })
}

export function identificationNumberCheck(data, params = {}) {
    return axios({
        method: "POST",
        url: `${fetchUrl}check-identification-number/${data}/`,
        params
    }).then(res => {
        return res.data
    }).catch(err => {
        return false
    })
}

export function vinCheck(params = {}) {
    return axios({
        method: "GET",
        url: `${fetchUrl}vehicle-full-data/`,
        params
    }).then(res => {
        return res.data
    }).catch(err => {
        return false
    })
}

export function authorize(endpoint) {
    return axios({
        method: "POST",
        url: `${fetchUrl}${endpoint}`
    }).then(res => {
        return {
            success: true,
            data: res.data
        }
    }).catch(err => {
        return {
            success: false,
            errors: fetchErrorCtrl(err)
        }
    })
}

export function authorizeCheck(endpoint, data = {}) {
    const isPrompt = !_isEmpty(data)
    return axios({
        method: isPrompt ? "POST" : "GET",
        url: `${endpoint}`,
        data
    }).then(res => {
        return res.data.authorized ? res.data.set_data : (isPrompt ? res.data.message : false)
    }).catch(err => {
        return !isPrompt
    })
}

export function doAjax(endpoint) {
    return axios({
        method: "POST",
        url: `${fetchUrl}${endpoint}`
    }).then(res => {
        return res.data.set_data
    }).catch(err => {
        return true
    })
}

export function initSignature(data, token) {
    return axios({
        method: 'POST',
        url: 'https://service.sign-it.cz/api/signature',
        data,
        headers: {'Signtoken': token}
    }).then(res => {
            return res.data.data
        }
    ).catch(err => {
        return false
    })
}

export function getSignature(hash, token) {
    return axios({
        method: 'GET',
        url: 'https://service.sign-it.cz/api/signature/' + hash,
        headers: {'Signtoken': token}
    }).then(res => {
            return res.data.data
        }
    ).catch(err => {
        if (err.response && err.response.data && err.response.data.message) {
            return err.response.data.message
        } else {
            return 'unexpected_error'
        }
    })
}

export const createDefaults = (identifier, params = {}) => {
    return axios({
        method: 'GET',
        url: fetchUrl + 'create-defaults/' + identifier + "/",
        params: params
    }).then(res => {
        return res.data
    }).catch(err => {
        return false
    })
}

export const getPickAssistants = (filter = {}) => {
    return axios({
        method: 'GET',
        url: fetchUrl + 'pick-assistant/',
        params: {...filter}
    }).then(res => {
        return res.data
    }).catch(err => {
        return false
    })
}

export const setPickAssistants = (id) => {
    return axios({
        method: 'POST',
        url: fetchUrl + 'set-assistant/',
        data: {id}
    }).then(res => {
        if(res.data.token && res.data.token_cookie_name){
            localStorage.setItem(res.data.token_cookie_name, res.data.token)
            setAuthTokens(res.data.token)
            window.location.reload()
        }
        return true
    }).catch(err => {
        return false
    })
}

export const postBillingData = (data, file = false) => {
    return axios({
        method: 'POST',
        url: fetchUrl + (file ? 'billingreport-check/' : "billingreport-checkarray/"),
        data
    }).then(res => {
        return {
            success: true,
            data: res.data
        }
    }).catch(err => {
        return {
            success: false,
            errors: fetchErrorCtrl(err)
        }
    })
}

export const postImportData = (data, id) => {
    return axios({
        method: 'POST',
        url: fetchUrl + `contracts/${id}/vehicles/import-check/`,
        data
    }).then(res => {
        return {
            success: true,
            data: res.data
        }
    }).catch(err => {
        return {
            success: false,
            errors: fetchErrorCtrl(err)
        }
    })
}

export const uncheckBillingData = () => {
    return axios({
        method: 'POST',
        url: fetchUrl + 'billingreport-uncheck/'
    }).then(res => {
        return {
            success: true,
            data: res.data
        }
    }).catch(err => {
        return {
            success: false,
            errors: fetchErrorCtrl(err)
        }
    })
}

export const uncheckImportData = (id) => {
    return axios({
        method: 'POST',
        url: fetchUrl + `contracts/${id}/vehicles/import-uncheck/`
    }).then(res => {
        return {
            success: true,
            data: res.data
        }
    }).catch(err => {
        return {
            success: false,
            errors: fetchErrorCtrl(err)
        }
    })
}

export const getDialCallData = (data) => {
    return axios({
        method: 'POST',
        url: fetchUrl + 'calls/dial/',
        data
    }).then(res => {
        return res.data
    }).catch(err => {
        return false
    })
}

export const dialCall = (data, url) => {
    return axios({
        method: 'POST',
        url,
        data,
        transformRequest: (data, headers) => {
            delete headers.common.Authorization
            return JSON.stringify(data)
        }
    }).then(res => {
        return res.data
    }).catch(err => {
        return false
    })
}

export const releaseCall = (url) => {
    return axios({
        method: 'PUT',
        url,
        transformRequest: (data, headers) => {
            delete headers.common.Authorization
        }
    }).then(res => {
        return res.data
    }).catch(err => {
        return false
    })
}

export const logCall = (data) => {
    return axios({
        method: 'POST',
        url: fetchUrl + 'calls/conclusion/',
        data
    }).then(res => {
        return true
    }).catch(err => {
        return false
    })
}

export const getBillingClosurePreview = () => {
    return axios({
        method: 'GET',
        url: fetchUrl + 'billing-closure-preview/'
    }).then(res => {
        return {
            success: true,
            data: res.data
        }
    }).catch(err => {
        return {
            success: false,
            errors: fetchErrorCtrl(err)
        }
    })
}

export const chooseBillingClosurePreview = (data) => {
    return axios({
        method: 'POST',
        url: fetchUrl + 'billing-closure-chosen-preview/',
        data
    }).then(res => {
        return res.data
    }).catch(err => {
        return false
    })
}

export function getData(endpoint, method, params) {
    const m = method || "GET"
    const p = m == "GET" ? {params} : {data: params}
    return axios({
        method: m,
        url: `${fetchUrl}${endpoint}`,
        ...p
    }).then(res => {
        return res.data
    }).catch(err => {
        return true
    })
}

export function doExport(endpoint, data, params = {}) {
    return axios({
        method: "POST",
        url: `${fetchUrl}${endpoint}`,
        data,
        params,
        responseType: "blob"
    }).then(res => {
        const href = window.URL.createObjectURL(res.data)
        const link = document.createElement('a')
        link.href = href
        const filename = (res.headers['content-disposition'] || "")
            .split(';')
            .find(n => n.includes('filename='))
            .replace('filename=', '')
            .replaceAll('"', '')
            .trim()
        link.setAttribute('download', filename || "export");
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        return true
    }).catch(err => {
        return false
    })
}

export function doImport(endpoint, data) {
    return axios({
        method: "POST",
        url: `${fetchUrl}${endpoint}/import/`,
        data
    }).then(res => {
        return true
    }).catch(err => {
        return false
    })
}

export function initCreate(endpoint) {
    return axios({
        method: 'POST',
        url: fetchUrl +  endpoint
    }).then(res => {
        return res.data.id
    }).catch(err => {
        return false
    })
}

export function doEndpoint(endpoint, method = "POST", params = {}) {
    const data = method == "POST" && !_isEmpty(params) ? params : {}
    return axios({
        method,
        url: fetchUrl + endpoint,
        params: method == "POST" ? {} : params,
        data
    }).then(res => {
            return {
                success: true,
                data: res.data
            }
        }
    ).catch(err => {
        return {
            success: false,
            data: fetchErrorCtrl(err)
        }
    })
}

export function searchTag(code, params) {
    return axios({
        method: 'GET',
        url: `${fetchUrl}tag/${code}/`,
        params
    }).then(res => {
            return res.data.tags.map(t => {
                return {label: t.label, value: t.id, color: t.color}
            })
        }
    ).catch(err => {
        return false
    })
}

export function assignTag(code, parent, data) {
    return axios({
        method: 'PUT',
        url: `${fetchUrl}tag/${code}/${parent}/`,
        data
    }).then(res => {
            return res.data
        }
    ).catch(err => {
        return false
    })
}

export function deleteTag(code, parent, id) {
    return axios({
        method: 'DELETE',
        url: `${fetchUrl}tag/${code}/${parent}/${id}/`
    }).then(res => {
            return true
        }
    ).catch(err => {
        return false
    })
}

export function searchContact(url, params) {
    return axios({
        method: 'GET',
        url: `${fetchUrl}${url}`,
        params
    }).then(res => {
            return res.data
        }
    ).catch(err => {
        return false
    })
}

export function assignContact(url, data) {
    return axios({
        method: 'POST',
        url: `${fetchUrl}${url}`,
        data
    }).then(res => {
            return res.data
        }
    ).catch(err => {
        return false
    })
}

export function postRequestDocuments(data) {
    return axios({
        method: 'POST',
        url: `${fetchUrl}documents-request-submit/`,
        data
    }).then(res => {
            return {
                success: true,
                data: res.data
            }
        }
    ).catch(err => {
        return {
            success: false,
            data: fetchErrorCtrl(err)
        }
    })
}
export function impersonateClient(client_id) {
    return axios({
        method: 'POST',
        url: `${fetchUrl}impersonate-client/${client_id}/`,
        data: {}
    }).then(res => {
            return {
                success: true,
                data: res.data
            }
        }
    ).catch(err => {
        return {
            success: false,
            data: fetchErrorCtrl(err)
        }
    })
}

export const refreshEnums = (identifier) => {
    return axios({
        method: 'GET',
        url: fetchUrl + 'refresh-enum/' + encodeURIComponent(identifier) + "/"
    }).then(res => {
        return res.data
    }).catch(err => {
        return false
    })
}